import { SupportedUserRoles } from '@insurancemenu/imenu-components-lib/dist/types';
import React from 'react';
import { Route, RouteProps } from 'react-router-dom';
import AppRedirect from './AppRedirect';

export interface RoleBasedRouteProps extends RouteProps {
  path: string;
  component: React.ComponentType;
  roleCheck?: (userRoles: SupportedUserRoles[]) => boolean;
  userRoles: SupportedUserRoles[];
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ component: Component, userRoles, roleCheck, ...rest }) => {
  const hasAccess = roleCheck ? roleCheck(userRoles) : true;
  return (
    <Route {...rest} render={(): JSX.Element => (hasAccess ? <Component /> : <AppRedirect userRoles={userRoles} />)} />
  );
};

export default RoleBasedRoute;
